import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { CategoryPicker, CategoryPickerProps } from './CategoryPicker';
import { getCategoryFilter } from './use-category-class';

const filter = getCategoryFilter(Entities.supplier);

type SupplierCategoryPickerProps = Omit<CategoryPickerProps, 'filter'>;

export function SupplierCategoryPicker(props: SupplierCategoryPickerProps) {
  return <CategoryPicker {...props} filter={filter} />;
}
